import { Component, Prop, Vue } from 'vue-property-decorator';

import '../../../../../../../node_modules/tiny-slider/src/tiny-slider.scss';
import { TinySliderInstance, TinySliderSettings, tns } from 'tiny-slider';

// @ts-ignore

const template = `
<div class="slider slider--th2">
  <div class="slider__next2" @click="nextSlide">
    <div class="slider__arr arr-right"></div>
  </div>
  <div class="slider__prev2" @click="prevSlide">
    <div class="slider__arr arr-left"></div>
  </div>
  <div class="slider__tns" ref='slider-container'>
    <img v-for="(img, k) in imgs" :key="img + k" :src="base + img" alt="" />
  </div>
</div>`;

@Component({
  template: template
})
export default class Slider2 extends Vue {
  @Prop({ default: 'slider--default' }) mainClass!: string;
  @Prop({ default: '' }) base!: string;
  @Prop({ default: () => [] }) imgs!: Array<string>;
  @Prop({
    default: () => {
      return {};
    }
  }) sliderOpts!: TinySliderSettings;

  private slider?: TinySliderInstance = undefined;
  private gallery: any = null;


  mounted() {
    this.slider = tns(
      Object.assign(
        {
          items: 3.3,
          autoWidth: true,
          controls: false,
          nav: false,
          loop: false,
          mouseDrag: true,
          swipeAngle: false,
          gutter: 1,
          container: this.$refs['slider-container'],
          speed: 400
        },
        this.sliderOpts
      )
    );
  }

  nextSlide() {
    this.slider?.goTo('next');
  }

  prevSlide() {
    this.slider?.goTo('prev');
  }
}
